import { dynamicConfigStringListIncludes } from '@atlaskit/tmp-editor-statsig/dynamic-config-value-contains';

/**
 * Name of the Statsig dynamic config that consolidates the standalone Review
 * Moment (Post Stream Review) feature flags into a single config. The config
 * holds a string list under its `value` key; a feature is enabled when its
 * token is present in that list. This replaces:
 *   - `platform_editor_review_moment_show_diff_by_default` (feature gate)
 *     → token `'show-diff-by-default'`
 *   - `platform_editor_review_moment_step_through` (experiment)
 *     → token `'step-through'`
 *
 * Semantics: an absent token (or unset / not-ready config) means the feature is
 * OFF — matching the previous default-off behaviour of both flags. Rollout is
 * an opt-in via the config's `value` list.
 */
const REVIEW_MOMENT_CONFIG = 'platform_editor_review_moment_config';

export const REVIEW_MOMENT_TOKENS = {
	showDiffByDefault: 'show-diff-by-default',
	stepThrough: 'step-through',
} as const;

/**
 * Whether the Review Moment opens with deletions shown by default. Replaces the
 * `platform_editor_review_moment_show_diff_by_default` feature gate.
 */
export function isReviewMomentShowDiffByDefaultEnabled(): boolean {
	return dynamicConfigStringListIncludes(
		REVIEW_MOMENT_CONFIG,
		REVIEW_MOMENT_TOKENS.showDiffByDefault,
	);
}

/**
 * Whether the step-through experience is available in the Review Moment.
 * Replaces the `platform_editor_review_moment_step_through` experiment.
 */
export function isReviewMomentStepThroughEnabled(): boolean {
	return dynamicConfigStringListIncludes(REVIEW_MOMENT_CONFIG, REVIEW_MOMENT_TOKENS.stepThrough);
}
